import { render, staticRenderFns } from "./lock_file_dropdown_item.vue?vue&type=template&id=60128cd8&vue3"
import script from "./lock_file_dropdown_item.vue?vue&type=script&lang=js&vue3"
export * from "./lock_file_dropdown_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports